import SeoHead from '@/components/SeoHead';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LanguageToggle from '../../components/LanguageToggle';
import Footer from '../home/components/Footer';

export default function TermsOfService() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title={lang === 'ar' ? 'شروط الخدمة - Debug' : 'Terms of Service - Debug'}
        description={lang === 'ar'
          ? 'اقرأ شروط الخدمة الخاصة بـ Debug. تعرف على حقوقك ومسؤولياتك عند استخدام خدماتنا.'
          : 'Read Debug\'s Terms of Service. Understand your rights and responsibilities when using our services.'}
        keywords="terms of service, user agreement, legal terms, service conditions, liability"
        canonical="https://debuging.com/terms-of-service"
        lang={lang}
      />
      {/* Navbar */}
      <nav className="bg-white shadow-lg fixed top-0 left-0 right-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/c83f6350fa782ce29b612b38d2cee1d4/3b7550d6c06eea93242f62b6efa2ff71.png" 
                alt="Debug Logo" 
                title="Debug - Software Development Company"
                className="h-10 w-auto"
              />
            </Link>

            <div className="flex items-center gap-4">
              <LanguageToggle />
              <Link 
                to="/"
                className="bg-[rgb(0,0,139)] text-white px-6 py-2 rounded-lg font-semibold hover:bg-[rgb(0,0,100)] transition-all cursor-pointer whitespace-nowrap"
              >
                {t('backToHome')}
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="pt-32 pb-20 px-4">
        <article className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">{t('termsOfService')}</h1>
          
          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('serviceDescription')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('serviceDescriptionText')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('userResponsibilities')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('userResponsibilitiesText')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('intellectualProperty')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('intellectualPropertyText')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('paymentTerms')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('paymentTermsText')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('limitation')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('limitationText')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">{t('termination')}</h2>
              <p className="text-gray-700 leading-relaxed">{t('terminationText')}</p>
            </section>
          </div>
        </article>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}